<template>
  <div class="news">
    <common-layout>
      <div slot="header">
        <h3>技术交易管理</h3>
      </div>
      <div slot="container">
        <div class="news-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="150" label="编号" align="center" />
            <el-table-column label="标题" align="center" prop="title" />
            <el-table-column label="添加日期" align="center" prop="createTime" />
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <!-- <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog :title="Title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form
        :model="newForm"
        ref="newForm"
        :rules="rules"
        label-width="100px"
        label-position="top"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="标题" prop="title">
              <el-input v-model="newForm.title" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="form-title">合同登记额分析统计</div>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="合同登记额分析登记"
              prop="contractRegistrationAmountAnalysisRegistration"
            >
              <template slot="label">
                <span class="labelTitle">合同登记额分析登记</span>
                <span class="labelmark">(数据顺序：按技术转让|技术咨询|技术服务|技术开发)</span>
              </template>
              <el-input
                v-model="newForm.contractRegistrationAmountAnalysisRegistration"
                clearable
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="合同登记额分析减免"
              prop="contractRegistrationAmountAnalysisAndExemption"
            >
              <template slot="label">
                <span class="labelTitle">合同登记额分析减免</span>
                <span class="labelmark">(数据顺序：技术转让|技术咨询 )</span>
              </template>
              <el-input
                v-model="newForm.contractRegistrationAmountAnalysisAndExemption"
                clearable
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登记总金额" prop="totalAmountOfRegistration">
              <el-input v-model="newForm.totalAmountOfRegistration" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="减免总金额" prop="totalAmountOfExemption">
              <el-input v-model="newForm.totalAmountOfExemption" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="form-title">最新一年统计</div>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="最新一年合同登记额分析统计标题"
              prop="newTitleOfContractRegistrationAmountAnalysisStatistics"
            >
              <el-input
                v-model="newForm.newTitleOfContractRegistrationAmountAnalysisStatistics"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="最新一年合同登记额分析统计数据"
              prop="newContractRegistrationAmountAnalysisAndStatistics"
            >
              <el-input
                v-model="newForm.newContractRegistrationAmountAnalysisAndStatistics"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最新一年合同统计分析说明" prop="newContractStatisticsAnalysis">
              <el-input v-model="newForm.newContractStatisticsAnalysis" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最新一年合同登记总额" prop="newTotalContractRegistrationAmount">
              <el-input v-model="newForm.newTotalContractRegistrationAmount" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最新一年合同减免" prop="newContractualRelief">
              <el-input v-model="newForm.newContractualRelief" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="form-title">合同登记年度、份数、免税统计</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同登记年度" prop="contractRegistrationYear">
              <template slot="label">
                <span class="labelTitle">合同登记年度</span>
                <span class="labelmark">(每年间用竖线相隔，如（2016|2017）)</span>
              </template>
              <el-input
                v-model="newForm.contractRegistrationYear"
                clearable
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同登记额(对应年份顺序)" prop="contractRegistrationAmount">
              <el-input
                v-model="newForm.contractRegistrationAmount"
                clearable
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="20" type="flex">
              <el-col :span="12">
                <el-form-item
                  label="合同登记份数（对应年份顺序）"
                  prop="numberOfContractRegistrations"
                >
                  <template slot="label">
                    <span class="labelTitle">合同登记份数（对应年份顺序）</span>
                  </template>
                  <el-input
                    v-model="newForm.numberOfContractRegistrations"
                    clearable
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="免税额(对应年份顺序)" prop="taxExemption">
                  <template slot="label">
                    <span class="labelTitle">免税额(对应年份顺序)</span>
                    <span class="labelmark">(按年份用竖线相隔)</span>
                  </template>
                  <el-input
                    v-model="newForm.taxExemption"
                    clearable
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-form-item style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('newForm')">提交</el-button>
          <el-button @click="closeForm('newForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from '../../../components/tinymce-editor/tinymce-editor';
import CommonLayout from '../../../components/common-layout.vue';
import { GetUrlName, FunDownload, DisabledDateFn } from '../../../utils/tool';

export default {
  components: {
    editor,
    CommonLayout
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      fileList: [],
      total: 10,
      per_page: 10,
      currentPage: 1,
      image: '',
      dialogFormVisible: false,
      Title: '',
      tableData: [],
      deleteRow: '',
      newForm: {
        title: '',
        annex: '',
        remark: '',
        image: '',
        content: '',
        date_time: '',
        is_publish: 2
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ],
        date_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur'
          }
        ],
        remark: [
          {
            required: true,
            message: '请输入摘要',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    headers() {
      return {};
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {
    this.getData('apij2/admin-api/voucher/large-screen-technology-transactions-management/page');
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    //富文本
    getQuillData(val) {
      this.newForm.content = val;
    },
    // 获取列表
    getData(url) {
      this.http
        .post(urlConfig.devUrl + url)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            this.currentPage = res.data.current_page;
            this.per_page = res.data.per_page;
          }
        })
        .catch(err => {
          console.log('开始搜索咨询err::', err);
        });
    },
    //新增
    addNews() {
      this.dialogFormVisible = true;
      this.Title = '新建';
      this.newForm = {
        title: '',
        remark: '',
        annex: '',
        content: '',
        date_time: '',
        is_publish: 2
      };
      this.fileList = [];
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.newForm = JSON.parse(JSON.stringify(row));
      //   this.http
      //     .put('apij2/admin-api/voucher/large-screen-technology-transactions-management/update', {
      //       id: row.id
      //     })
      //     .then(res => {
      //       if (res.code == 0) {
      //         this.newForm = {
      //           id: res.data.id,
      //           title: res.data.title,
      //           remark: res.data.remark,
      //           content: res.data.content,
      //           date_time: res.data.date_time,
      //           is_publish: res.data.is_publish
      //         };
      //         this.fileList = res.data.annex
      //           .split(',')
      //           .map(el => {
      //             return {
      //               name: GetUrlName(el),
      //               url: el
      //             };
      //           })
      //           .filter(d => d.url);
      //       }
      //     });
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http.request('news_notice/' + row.id, '', 'delete').then(res => {
            if (res.code == 0) {
              this.ResetSearch(['searchValue']);

              this.getData(
                `apij2/admin-api/voucher/large-screen-technology-transactions-management/page`
              );
              this.$message({
                type: 'success',
                message: '删除成功'
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error'
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //   this.newForm.annex = this.fileList
          //     .map(el => {
          //       return el.url;
          //     })
          //     .join(',');
          if (this.Title == '新建') {
            // this.newForm.date_time = this.pbcFun.formatDate(
            //   new Date(this.newForm.date_time),
            //   'yyyy-MM-dd hh:mm:ss'
            // );

            this.http
              .post(
                'apij2/admin-api/voucher/large-screen-technology-transactions-management/create',
                this.newForm
              )
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);

                  this.getData(
                    `apij2/admin-api/voucher/large-screen-technology-transactions-management/page`
                  );
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  });
                }
              });
          }
          if (this.Title == '编辑') {
            let obj = JSON.parse(JSON.stringify(this.newForm));
            this.http
              .put(
                urlConfig.devUrl +
                  'apij2/admin-api/voucher/large-screen-technology-transfer-management/update',
                obj
              )
              .then(res => {
                if (res.code == 0) {
                  this.getData(
                    `apij2/admin-api/voucher/large-screen-technology-transactions-management/page`
                  );
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  });
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
    },
    //发布
    release(row, value) {
      // this.$confirm("此操作将发布新闻, 是否继续?", "提示", {
      // 		confirmButtonText: "确定",
      // 		cancelButtonText: "取消",
      // 		type: "warning",
      // 		center: true
      // 	})
      // 	.then(() => {
      let message = value == 2 ? '取消发布' : '发布成功';
      this.http
        .put('news_notice/' + row.id, {
          is_publish: value
        })
        .then(res => {
          if (res.code == 0) {
            this.getData(
              `apij2/admin-api/voucher/large-screen-technology-transactions-management/page`
            );
            this.$message({
              type: 'success',
              message: message
            });
          } else {
            this.$message({
              message: message,
              type: 'error'
            });
          }
        });
      // })
      // .catch(() => {
      // 	this.$message({
      // 		type: "info",
      // 		message: "已取消发布"
      // 	});
      // });
    },
    //查找
    search() {
      this.getData('apij2/admin-api/voucher/large-screen-technology-transactions-management/page');
    },
    selectionChange(selection) {
      this.deleteRow = '';
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(',');
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData(
        `apij2/admin-api/voucher/large-screen-technology-transactions-management/page?page=${val}`
      );
    },

    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64
            })
            .then(res => {
              this.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    getList(fileList) {
      return fileList.map(el => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid
        };
      });
    },
    onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.image = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.news {
  width: 100%;
  height: 100%;
  .news-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  .news-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
  /deep/ .el-form--label-top .el-form-item__label {
    float: inline-start;
    padding: 0;
  }
  .labelTitle {
    font-size: 14px;
    color: #606266;
  }
  .labelmark {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
  }
  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
}
</style>
